var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4009 19.8551L11.9156 11.3698L3.43028 2.88456L5.12734 1.1875L22.0979 18.1581L20.4009 19.8551Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7284 16.0836C22.7284 16.1258 22.7235 16.1663 22.7144 16.2046L21.0285 14.5187L21.0291 8.57759L17.5631 11.0533L14.6355 8.12571V6.82667H13.3364L11.2973 4.78749H15.6551C16.2182 4.78749 16.6747 5.24398 16.6747 5.80708V9.5996L21.9223 5.85129C22.2597 5.61028 22.7284 5.85147 22.7284 6.26613V16.0836Z",
    fill: "#CCCFD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6747 14.7625L14.6355 12.7233V16.003H4.43957V6.82667H8.73882L6.69963 4.78749H3.41998C2.85688 4.78749 2.40039 5.24398 2.40039 5.80708V17.0226C2.40039 17.5857 2.85688 18.0422 3.41998 18.0422H15.6551C16.2182 18.0422 16.6747 17.5857 16.6747 17.0226V14.7625Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamOff);
export default __webpack_public_path__ + "static/media/icon-cam-off.e6cea73cf361c49894844c01cf804b20.svg";
export { ForwardRef as ReactComponent };